import {useDispatch, useSelector} from 'react-redux'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import ModalDelete from '../../../../components/Modals/Generales/ModalDelete'
import {State} from '../../../../reducers'
import {
  gc_lc_OpenModalEliminarCliente,
  gc_lc_OpenModalEstatus,
  gc_lc_SetClienteSeleccionado,
  gc_lc_EliminarClienteConfirm,
  gc_lc_ChangeEstatusCliente,
  gc_lc_OpenModalVerificacion,
  gc_lc_MarcarVerificacionRevisada,
} from '../../../../actions/gestion-cliente/lista-cliente/listaCliente.actions'
import {VerificacionDato} from '../../../../interfaces/verificacion-datos.interface'

const ModalsControlsCliente = () => {
  const {activeEliminar, activeEstatus, activeVerificacion} = useSelector(
    (state: State) => state.gestionCliente.listarClientes.modales
  )
  const {clienteSeleccionado} = useSelector((state: State) => state.gestionCliente.listarClientes)
  const dispatch = useDispatch()

  const closeModalEliminar = () => {
    dispatch(gc_lc_OpenModalEliminarCliente(false))
    dispatch(gc_lc_SetClienteSeleccionado(null))
  }

  const closeModalEstatus = () => {
    dispatch(gc_lc_OpenModalEstatus(false))
    dispatch(gc_lc_SetClienteSeleccionado(null))
  }

  const closeModalVerificacion = () => {
    dispatch(gc_lc_OpenModalVerificacion(false))
    dispatch(gc_lc_SetClienteSeleccionado(null))
  }

  const motivosSeleccionados: Array<VerificacionDato> =
    (clienteSeleccionado as any)?.motivosVerificacion ?? []

  const detalleVerificacion = (
    <>
      <span>
        {`Revise la información de ${clienteSeleccionado?.nombre ?? 'este cliente'} antes de emitirle documentos con la normativa 2.0. Esta advertencia no le impide facturar.`}
      </span>
      {motivosSeleccionados.map((motivo) => (
        <span key={motivo.codigomotivo} style={{display: 'block', marginTop: '12px'}}>
          <strong>{motivo.titulo}</strong>
          <span style={{display: 'block'}}>{motivo.mensaje}</span>
          {motivo.querevisar && (
            <span style={{display: 'block', marginTop: '4px', opacity: 0.7}}>
              {`Qué revisar: ${motivo.querevisar}`}
            </span>
          )}
        </span>
      ))}
      <span style={{display: 'block', marginTop: '12px'}}>
        Si ya revisó estos datos y están correctos, presione Marcar como revisado para quitar la
        advertencia. Quedará registrado quién la quitó y cuándo.
      </span>
    </>
  )

  return (
    <>
      {activeEliminar && (
        <ModalDelete
          title='Eliminar cliente'
          detail={`¿Seguro que quieres eliminar el cliente ${clienteSeleccionado?.nombre}?`}
          messageAction='Eliminar'
          actionDelete={() => dispatch(gc_lc_EliminarClienteConfirm())}
          closeModalDelete={closeModalEliminar}
          Styles={{minWidth: '25%', maxWidth: '700px'}}
        />
      )}

      {activeVerificacion && (
        <ModalConfirm
          title='Verificación de datos del cliente'
          detail={detalleVerificacion}
          messageAction='Marcar como revisado'
          messageClose='Cerrar'
          actionConfirm={() => dispatch(gc_lc_MarcarVerificacionRevisada())}
          closeModalConfirm={closeModalVerificacion}
          Styles={{minWidth: '25%', maxWidth: '700px'}}
        />
      )}

      {activeEstatus && (
        <ModalConfirm
          title={`${clienteSeleccionado?.activo === 'Activo' ? 'Desactivar' : 'Activar'} cliente`}
          detail={`¿Seguro que quieres ${clienteSeleccionado?.activo === 'Activo' ? 'desactivar' : 'activar'} el cliente ${clienteSeleccionado?.nombre}?`}
          actionConfirm={() => dispatch(gc_lc_ChangeEstatusCliente())}
          closeModalConfirm={closeModalEstatus}
        />
      )}
    </>
  )
}

export default ModalsControlsCliente
